import React, { useState } from 'react';
import classNames from 'classnames';
import VisibilityConditionsModal from "../VisibilityConditionsModal";

const ItemVisibilityConditionsSettings = (props) => {
  const [modalOpenState, changeModalOpenState] = useState(false)
  const logical = props.conditionsGroupLogical.value
  const conditions = props.conditions.value

  const openItemVilibilityConditionsModal = () => {
    changeModalOpenState(true)
  }

  if (!Object.keys(props.recipientParameters).length) return null

  if (modalOpenState) {
    return(
      <VisibilityConditionsModal
        {...props}
        changeModalOpenState={changeModalOpenState}
      />
    )
  }

  const t = (k) => k.startsWith('is') || k.startsWith('c') ? i18n.t(`condition_operators.${k}`) : k;

  const conditionsView = () => {
    return conditions.map( ({ parameter, condition, value }, i) => {
      return(
        <div className="condition-items"key={i}>
          <div className="parameter"> {parameter} </div> &nbsp;
          <div className="condition"> {t(condition)} </div> &nbsp;
          {!condition.startsWith('is') && <div className="value"> {value} </div>}
        </div>
      )
    })
  }

  return (
    <>
      <div className="conditions-description">
        <div className="logical">{
          conditions.length ?
          <div>
            <label>{ i18n.t('condition_check') }:</label> &nbsp;
            <div className="title">{i18n.t(`condition_operators.${logical}`)}</div>
          </div> : <div className="title-empty">{ i18n.t('condition_empty') }</div> }
        </div>
        <div className="edit-condition">
          <a onClick={openItemVilibilityConditionsModal}>{ i18n.t('change') }</a>
        </div>
      </div>
      { conditions.length ?
        <div className="conditions">
          {conditionsView()}
        </div> : null
      }
    </>
  );
};

export default ItemVisibilityConditionsSettings;
